import { populate } from "populate";

const raw = {
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: "b664abcc-46e8-42f9-b3d8-d741c548a99e",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "dfeec50c-ba58-40a9-ac66-529762b9d324",
      type: "Sprite",
      name: "ground",
      nameSpace: "",
      className: "",
      x: 0,
      y: 380,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fbconnect_cat_grass",
      parent: "b664abcc-46e8-42f9-b3d8-d741c548a99e",
      data: ""
    },
    {
      id: "3110cecf-d439-453e-bb6c-67f4ad1916b7",
      type: "Sprite",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_background",
      parent: "b664abcc-46e8-42f9-b3d8-d741c548a99e",
      data: ""
    },
    {
      id: "ac59b81d-8add-4ee2-a999-db5789c6281d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_title_bg",
      parent: "3110cecf-d439-453e-bb6c-67f4ad1916b7",
      data: ""
    },
    {
      id: "9584b77a-ec10-41af-ac0f-b2b0f856b893",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 342,
      y: -257,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_close",
      parent: "3110cecf-d439-453e-bb6c-67f4ad1916b7",
      data: ""
    },
    {
      id: "c9545e51-b2b7-496f-b728-8634e16bb209",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fbconnect_pic_1",
      parent: "3110cecf-d439-453e-bb6c-67f4ad1916b7",
      data: ""
    },
    {
      id: "69b3481e-28ef-48b1-a0bd-d95e6d55af38",
      type: "Sprite",
      name: "connectButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 298,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_blue",
      parent: "3110cecf-d439-453e-bb6c-67f4ad1916b7",
      data: ""
    },
    {
      id: "2bf8d564-1644-4f02-bd64-072175b6cd8b",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 176,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "ConnectFbPopupText",
      localize: true,
      maxWidth: 691,
      maxHeight: 102,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BB3C2F",
        stroke: "black",
        strokeThickness: 0,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "3110cecf-d439-453e-bb6c-67f4ad1916b7",
      data: ""
    },
    {
      id: "269093e7-80ba-4166-9cd9-89f3c7d9f253",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Facebook",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 44,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#AB3145",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "ac59b81d-8add-4ee2-a999-db5789c6281d",
      data: ""
    },
    {
      id: "bda55d2e-b558-4179-a00c-1627e0cf4f42",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Connect",
      localize: true,
      maxWidth: 206,
      maxHeight: 98,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#2C528D",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "69b3481e-28ef-48b1-a0bd-d95e6d55af38",
      data: ""
    }
  ]
} as const;

export class ConnectFbPopupLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  ground: GameObject<PIXI.Sprite>;
  bg: GameObject<PIXI.Sprite>;
  closeButton: GameObject<PIXI.Sprite>;
  connectButton: GameObject<PIXI.Sprite>;

  constructor() {
    populate(this, raw);
  }
}
